import script from "./cameraPage.vue?vue&type=script&setup=true&lang=js"
export * from "./cameraPage.vue?vue&type=script&setup=true&lang=js"

import "./cameraPage.vue?vue&type=style&index=0&id=b44626f2&lang=scss&scoped=true"

import exportComponent from "/jenkins/workspace/zh-operate-subapp_prev/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b44626f2"]])

export default __exports__